<template>
  <div class="page-content" id="vue">
    <img width="1920" height=" 260" src="@/assets/images/page-1_img001.jpg" alt="right">


    <section class="well well-md well--inset-5 text-md-left text_center_small">
      <div class="container">
        <div class="row flow-offset-2">

          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Therapeutic Facials">Hydro-Diamond Treatment  </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                Remove layers of dead cells with spinning instrument.
                Safe, non-invasive, provides the skin with a blast of
                essential electrolytes, vacuum cleaning, deep hydration
                for flawless texture and perfect complexion. The service
                ends with boosting rich mask loaded with antioxidants,
                proteins and organic plant ingredients.

              </p>
              <div style="text-align:right">
                <p style="color:#614051;">80 min / $175</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2>Premium - Double lift & Sculpt<br class="md-visible">
              Non Invasive/No Recovery  </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                With the deep radiofrequency energy, the dermis and
                subcutaneous layers are heated, forcing collagen fibers
                to contract, causing the dermis to thicken, stimulating
                proteins, creating immediate tightening/iifting effect.
                Producing new collagen fibers which last long term.
                Treatment also improves skin tone and texture. Results
                are immediately noticeable. As oxygen infusion has a
                strengthening effect on skin and cellular respiration.

              </p>
              <p style="color:#614051;">Why Clients Love It:</p>
              <p style="margin-top: 0">Best suited for loose or sagging skin.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;">80 min / $225</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2>Mesotherapy Treatment  </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                Mesotheropy is a needle-free application of nutrients to
                the skin to increase absorbency. Frequency set at the
                level where vitamins, minerals and amino-acids will
                travel the perfect depth into the skin. This process
                combats free radicals, stimulale cellular activity, better
                circulation, improves lymphatic drainage and collagen,
                elasticity production. Vitamin C and hyaluronic acid
                specially improves radiance and glow.
              </p>
              <p style="color:#614051;">Why Clients Love It:</p>
              <p style="margin-top: 0">Included LED light ond customize mask.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;">60 min / $175</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Therapeutic Facials">Vacuum Air Massage </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                Lymphatic Elumination of Toxins and Tissue Waste.
                Helps to increase blood supply to force, speed up cell
                metabolism. circulatory system, brings fresh oxygen and
                nutrients to the area. Provides soothing effect on sensory
                nerve endings. Prevents sogging, minimizes fine lines.
                Treatment includes <strong>Micro-Current</strong> and LED Light
                Therapy follow with <strong>Customized Mask Application</strong>

              </p>

              <div style="text-align:right">
                <p style="color:#614051;">60 min / $150</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2>Natural Diamond Tips - Microdermabrasion </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                Microdermabrasion is used to improve the superficial
                skin layers by eliminating dead skin cells and to
                stimulate collagen production, improves elasticity and
                tightness, reduce pigmentation, fine lines as <strong>Oxygen
                Therapy</strong> restores and lock in hydration. <strong>Diamond
                Microdermabrasion</strong> uses various size coarseness
                for different skin types and resurfacing depth.
                Treatment does not cause any irritation to the skin.
                <strong>Results are cumulative overtime.</strong>. 
              </p>

              <div style="text-align:right">
                <p style="color:#614051;">45 min / $135</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2>Power Peel </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">
                Targeting your most stubborn complexion, large pores,
                dullness, uneven skin tone and fine lines. A multi-step
                process that combines several peeling agents that
                effectively exfoliate with phytonutrient-rich botanicals to
                wipe away residual debris, polish and refine, followed by
                <strong>LED Light</strong> and an <strong>Organic Firming</strong> and <strong>Brightening </strong>
                Mask that suits your skin for luminous results.
              </p>

              <div style="text-align:right">
                <p style="color:#614051;">45 min / $175</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>


          <!--old services-->
          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Therapeutic Facials">Brightening  <br class="md-visible">
            Face Therapy</h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">This treatment calls upon the most brightening agents nature has to offer: mushroom extracts, triple vitamin C, bromelaine and other enzymes, plus whitening collagen mask applied with electroporation open a pathway in the skin allowing a deeper penetration of products.</p>
              <p style="color:#614051;">Why Clients Love It:</p>
              <p style="margin-top: 0">One of the favorite facials, it yields immediate results after just one treatment.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;">70 min / $145</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Microneedling Facial<br class="md-visible">New Collagen Formation</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051; margin-top: 0">Why It Is Effective</p>
              <p style=" margin-top: 0">A non-surgical precise stimulation creates controlled micro-perforations that are safe on all skin types. This leads to fibroblast production, enhances blood circulation and the absorption of nutrients to the skin. The results range from the reduction of fine lines to the improvement of post-acne scarring and skin texture laxity and reduction of pore size. Micro-perforations are made in the skin using ultra-thin needles to activate its natural self-repair functions. 
              </p><br>
              <p style="color:#614051; margin-top: 0">Why Clients Love It:</p>
              <p style=" margin-top: 0">The path to radiant skin has never been easier.</p>
              <div style="text-align:right">
                <p style="color:#614051; margin-top: 0">75 min / $160</p>
                <p style=" margin-top: 0">Recommended in a series of six treatments</p>
                <p style=" margin-top: 0">for best results</p>
              </div>          
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>RF Radio-Frequency <br class="md-visible">Facial</h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">This therapy is based on high-frequency radio waves that heat up the dermis and the collagen fibers of the skin so they contract, giving the face’s skin a tighter look. Additionally, heating activates the fibroblasts to produce more collagen and elastin fibers for a long-lasting skin tightening sensation.</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Instant stimulation, helps the skin appear more lifted, toned and plump. Use insummer, as there is no photo-sensitivity .</p><br>
              <div style="text-align:right">
                <p style="color:#614051;">75 min / $165</p>
                <p style="margin-top: 0">Recommended in series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Therapeutic Facials">Rosacea Soothing<br class="md-visible">
             Treatment  </h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Calming and balancing facial, perfect for the most delicate and irritated skin. We use gentle cleansing products, a hydrating premium botanical mask and LED cell repair. Cold Beauty Globes are rolled over the face at the end of the procedure for a refreshing healthy glow.</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Calms stressed skin, cools, leaves complexion fresh and hydrated.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0"> 75 min / $110</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Acne Detox Facial<br class="md-visible"></h2>
            <div class="text-md-justify"><br>
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">A deep pore cleaning facial for excessive oil secretion and acne. This therapeutic treatment helps to manage and control acne while clarifying and calming troubled skin. Followed by LED Blue, clinically proven to heal and repair inflamed skin, decreasing acne drastically with absolutely no downtime. Follow by sebum regulating mask application. </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">It yields immediate results after just one treatment thanks to professional anti-acne concept</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0">70 min / $115</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>          
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Microdermabrasion + LED Red <br class="md-visible"></h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Microdermabrasion is really effective for wrinkled and fine lined skin, after acne marks, regardless of skin color. Encourages cell turnover and preps the dermis for maximum absorption of soothing ingredients. In the end LED Red works to restore the skin’s natural cellular activity and promotes tissue regeneration and collagen and elastin production.</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">No recovery time, any time of the year. Return to your normal lifestyle immediately. Reduces pore size.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0">$115<br></p>
                <p style="margin-top: 0">Recommended in series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Facials">Millennial Breakout <br class="md-visible">
             Maintenance Facial</h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Botanical joint forces extract, removes waste and rids skin of bacteria. Anti-inflammatory agent will correct excessive sebum production. </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Facial service that harnesses safe benefits for pore clogging sebum.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0">45 min / $90</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Bikini Facial<br class="md-visible"></h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">Unhappy with ingrown hair? Pimples? Damaged skin? We go to the root of the problem. Great extraction, comfortable cleaning. The use of LED Blue will destroy bacteria and an anti-inflammatory mask will calm the area </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">The skin heals fast, free of impurities and build up of dead skin cells.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0">60 min / $90</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>          
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Back Facial <br class="md-visible"></h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Back cleansing is a fundamental aspect of most people’s regimens. The skin is exfoliated, pores unclogged and a detoxifying mask leaves nothing behind.</p><br>
              <p style="color:#614051;">Why Clients Love It:</p>
              <p style="margin-top: 0">The skin feels supple, hydrated, smooth,red carpet ready.</p><br>
              <div style="text-align:right">
                <p style="color:#614051;margin-top: 0">60 min / $95</p>
                <p style="margin-top: 0">Recommended in series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>

          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Facials">Lamprobe Treatment<br class="md-visible">
             of Minor Skin Irregularities</h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Lamprobe works on the principle of high-frequency/radio-frequency technology utilizing a current that is attracted to liquids on the skin surface, eliminating fibromas, skin tags, cherry angiomas, broken capillaries. </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Heals fast, non-invasive, creates a flawless skin, instant results with just one treatment.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">45 min / $90</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>                        
            </div>              
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Are Aging Hands Spoiling<br class="md-visible">
            Your Fun?</h2><br>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">Ultrasonic exfoliation will be followed by a cocktail of resurfacing solutions for brightening action. Kyolic acid, licorice root and vitamin C help decrease fine lines and hyper-pigmentation. Vitamin K and peptides will strengthen blood vessel walls and help lighten skin.</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Every beautiful skin has a secret. This could be yours.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">$25</p>
                <!--Recommended in a series of six treatments<br>
                (pay for five)-->
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Popular Face Massage<br class="md-visible"></h2>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Will bring radiance, increase lymph flow and reduce inflammation. Follow by brightening 100% natural herbal mask.</p><br> 
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">It provides an immediate, visible anti-aging effect and unified complexion.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">10 min / $20</p>
                <p style="margin-top: 0">20 min / $30</p>
                <p style="margin-top: 0">30 min / $40</p>
                <p style="margin-top: 0">Recommended in series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Facials">XTR - Multi-platform<br class="md-visible">
             5 Treatments in 1</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective: </p>
              <p style="margin-top: 0">Provides a non-surgical “Lifting Effect.” Five highly specialized rejuvenation treatments that target and reduce the major signs of aging for outstanding results that are visible at the very first session.</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">Tones the skin, emphasizes the facial contour, reduces the appearance of wrinkles, leaves the face looking radiant.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">60 min / $180<br></p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>              
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Facial with Hot Paraffin Mask<br class="md-visible"></h2>
            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">Very pleasant, warming, plumping effect for dry, ultra dry or super dry skins, especially recommended during winter to nourish and soften. After cleansing and exfoliating relax, while the power of the mask hydrates the skin. </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">You will leave with a lightly pink and glowing complexion. In the next morning the skin appears more vibrant and plump.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">60min / $110</p>
                <p style="margin-top: 0">Recommended in a series of six treatments<p/>
                <p style="margin-top: 0">(pay for five)</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Chemical Peel<br class="md-visible">Natural Plant-based Treatment</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">This program uses unique fruit acids to give that fresh look. Provides powerful, non invasive, pro-youth improvements to the skin, removes the thickened rough layer of the dermis, reduces the level of wrinkles and pigmental spots, increases collagen and elastin production</p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">After receiving this treatment client immediately sees instant luminosity with minimal downtime. This program is best performed in a series of three to six treatments Discount on package, facial included.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">75 min / $185</p>
                <!--Recommended in series of six treatments<br>
                (pay for five)-->
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Facials">Express Facial</h2><!--br style="line-height:0.5em;">--<br class="md-visible">-->
            <h6>Perfect for the time pressed client</h6><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">For the client who wants a polished look in
                minimal time. After an analysis to select
                the best products for your face, your skin
                is cleansed, lightly exfoliated and massaged
                to improve micro circulation. A mask will
                complete the experience with a relaxing
                serum and vitamin finishing cream to protect
                the skin from external aggressions.
                </p><br>
                <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
                <p style="margin-top: 0">It moisturizes, restores and balances
                dehydrated skin.</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">45 min / $80</p>
                  <p style="margin-top: 0">Recommended in a series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
                </div>                        
            </div>              
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Eye Lift Renewal Session + LED Red</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">An intensive treatment to relieve signs of
                fatigue and tension from the eye area.
                It begins with a gentle cleansing and massage
                on frontal and temporal areas. Micro currents
                will lift sagging skin and specific eye serum will
                improve the appearance of swelling and circles
                under the eyes. Finishes with LED Red.
                </p><br>
                <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
                <p style="margin-top: 0">Clients see immediate, visible results.
                Treatment promotes cellular longevity and repair.</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">30min / $60</p>
                  <p style="margin-top: 0">Recommended in a series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
                  <p style="margin-top: 0">Eye Lash Thining  20min / $18</p>
                  <p style="margin-top: 0">Eye Brow Thining  20min / $20</p>
                </div>         
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Hydration Therapy<!--<br class="md-visible">--></h2>
            <h6>Treatment for Hands and Feet</h6><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">Several benefits to warm paraffin include:
                Removal of toxins from cells
                enhanced blood flow
                relaxation of sore, stiff muscles
                Relief of painful arthritic joints
                Increased function of tissue cells</p><br>
                <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
                <p style="margin-top: 0">Comes with single-use sanitary gloves and
                slippers, eliminating any risk of fungal
                cross contamination.</p>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">Hands $25</p>
                  <p style="margin-top: 0">Feet $35</p>
                  <p style="margin-top: 0">Recommended in series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
                </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2 data-text="Facials">Casmara Treatments<br class="md-visible">
             Inventors of the Original Algae Peel-off Mask, Since 1979</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Elixircell:</p>
              <p style="margin-top: 0">Disorders during and around
                menopause. High technology thermoactive
                facial. Facelift effect, natural balance,
                energizes, tones / 2 masks included.
                Suitable: sign of menopause</p><br>
              <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">75 min / $175</p>
              </div>              
              <p style="color:#614051;">Intensive Q10:</p>
              <p style="margin-top: 0">Stimulant of collagensynthesis.
                Very dry skin - rejuvenating, nourishing and
                anti-aging action,high in vitamin C, dill,
                Hyaluronic acid
                Suitable: mature, demanding skins</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">75 min / $145</p>
                </div>

              <p style="color:#614051;">RGnerin: </p>
              <p style="margin-top: 0">Botox effect treatment without
                injection or side effects. Wrinkle filler, improves
                micro-contour of the skin.
                Suitable: Mature skin types</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">75 min / $165</p>
                </div>
                
              <p style="color:#614051;margin-top: 0">Goji Tibetan Secret: </p>
              <p style="margin-top: 0">Antioxidant, intensive, long lasting moisturization. The fruit of longevity.</p><br>
              <div style="text-align: right">
                <p style="color:#614051;">75 min / $145</p>                  
              </div>
                
              <p style="color:#614051;margin-top: 0">Ocean Miracle: </p>
              <p style="margin-top: 0">Seaweed plasma, cell detox,
                deep firming effect, restores lost volume.
                Suitable: Mature skin that needs profound
                firming.</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">75 min / $150</p>
                </div>
                
              <p style="color:#614051;">Shinestop Treatment - Detox: </p>
              <p style="margin-top: 0">Suitable For: Oily, bacterial skin
                Properties - Dermopurifying, matte effect</p><br>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">75 min / $145</p>
                  <p style="margin-top: 0">Recommended in a series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
                </div>                        
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Facial Therapy with <br class="md-visible">
            BT “Micro Advanced Technology” for Skin Rejuvenation</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective</p>
              <p style="margin-top: 0">We start with European facial, then perform
                BT micro-ultrasonic exfoliation. It works
                by creating high speed oscillations which,
                in turn, expedites the removal of stratum
                corneum leaving skin smoother, plumper
                and firmer. Micro-current helps tone the
                muscles in the skin and increases circulation
                </p><br>
              <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
              <p style="margin-top: 0">This is a “one size fits all” treatment that
                offers amazingly visible brightening action.</p><br>
              <div align="right">
                <p style="color:#614051;margin-top: 0">75min / $135</p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div><br>
                
                <p>Add on service: BT alone, plus oxygenating treatment</p>
                <div align="right">
                  <p style="color:#614051;margin-top: 0">30min / $55</p>
                  <p style="margin-top: 0">Recommended in a series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
              </div>
              <br>
              
              <h2 style="text-align: left;">Micro Current Treatment ONLY<br class="md-visible"></h2>

              <p class="text-md-justify">
              Oxygenating mask included
              </p><br>
              <div align="right">
                <p style="color:#614051;margin-top: 0">45min / $95<br></p>
                <p style="margin-top: 0">Recommended in a series of six treatments</p>
                <p style="margin-top: 0">(pay for five)</p>
              </div>                        
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Neck and Decollete Facial<br class="md-visible">with LED Red (used on photo-damaged skin)</h2><br>

            <div class="text-md-justify">
              <p style="color:#614051;margin-top: 0">Why It Is Effective:</p>
              <p style="margin-top: 0">A specialized service for a delicate area.
                It has been created to improve the skin’s
                appearance, as a topical booster sends
                signals to the skin cells stimulating them to
                produce more collagen. Vitamin C with
                hyaluronic acid are an especially smart way
                to soften lines and wrinkles, improving an
                uneven skin tone.</p><br>
                <p style="color:#614051;margin-top: 0">Why Clients Love It:</p>
                <p style="margin-top: 0">It is anti-aging, yet also works for skin that
                needs extra TLC!</p>
                <div style="text-align: right">
                  <p style="color:#614051;margin-top: 0">45min / $95</p>
                  <p style="margin-top: 0">Feet $35</p>
                  <p style="margin-top: 0">Recommended in series of six treatments</p>
                  <p style="margin-top: 0">(pay for five)</p>
                </div>
                <br>
              
              <h2>Back, Neck, Shoulder massage and Back/Head Indian Massage<br class="md-visible"></h2>            
              
              <div style="text-align: right">
                <p style="color:#614051;margin-top: 0">10min / $20</p>
                <p style="margin-top: 0">15min / $30</p>
                <p style="margin-top: 0">20min / $40</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <br><br>
            <img src="@/assets/images/page-1_img07.jpg" alt="">
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <h2>Enhanced Treatments<br class="md-visible"></h2>     
            May be added on to any service
            <ul class="marked-list">
              <li>Ampule</li>
              <li>Collagen Mask</li>
              <li>Paraffin Mask</li>
              <li>LED photo light Therapy<br>
                (Rosacea, Acne, Oily, Dry)</li>
              <li>Microdermabrasion</li>
              <li>Micro-Current Lifting Treatment</li>
            </ul>
          </div>
          <div class="col-md-4 col-md-preffix-.75">
            <br><br>          
            <img width="370" height="329" src="@/assets/images/page-1_img04.jpg" alt="right">
          </div>
        </div>
      </div>
    </section>



    <!-- Two Column  -->
    <section class="well well-xs text-md-left text_center_small">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-preffix-1">
            <h2 data-text="A.La.Carte">Pricing</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-5 col-md-preffix-1">
            <h5>Make-Up</h5><br>
            <p class="text-md-justify">From day to evening looks </p>
            <hr>
            <div style="color:#614051;">
              <p style="text-align:left; margin-top: 0;">- Elegant Make-up Application<span style="float:right;">45min / $85</span></p>
              <p style="text-align:left; margin-top: 0;">- Make-up Constultation & lesson<span style="float:right;">90min / $180</span></p>
              <p style="text-align:left; margin-top: 0;">- Delicate Make-up<span style="float:right;">$50</span></p>
            </div>
          </div>
          <div class="col-md-5 col-md-preffix-1">
            <h5>Body Waxing</h5>
            <p class="text-md-justify">Do not apply lotion prior to bing waxed (also hair growth must be 3 to 4 weeks grow for maximum result).</p>
            <hr width="100%">
            <div style="color:#614051;">
              <p style="text-align:left; margin-top: 0">-Ear<span style="float:right;">$15</span></p>
              <p style="text-align:left; margin-top: 0">-Eye Brows Complete Shaping<span style="float:right;">$18 - $22</span></p>
              <p style="text-align:left; margin-top: 0">-Eye Brows Simple Cleaning<span style="float:right;">$14</span></p>
              <p style="text-align:left; margin-top: 0">-Eye Brows tweezing<span style="float:right;">$18 - $22</span></p>
              <p style="text-align:left; margin-top: 0">-Upper, Lower Lip<span style="float:right;">$39</span></p>
              <p style="text-align:left; margin-top: 0">-Full Face<span style="float:right;">$39</span></p>
              <p style="text-align:left; margin-top: 0">-Sideburns<span style="float:right;">$13</span></p>
              <p style="text-align:left; margin-top: 0">-Chin<span style="float:right;">$14</span></p>
              <p style="text-align:left; margin-top: 0">-Neck<span style="float:right;">$39</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END End Two Columns-->

    <h5 class="text-center">Body Waxing Customized</h5>
    <!-- Two Column  -->
    <section class="well well-xs text-md-left text_center_small">
      <div class="container">
        <div class="row">
          <div class="col-md-5 col-md-preffix-1">
            <p class="text-md-justify">For Regular Skin using PINE RESIN.</p>
            <hr  width="100%">
            <div style="color:#614051;">
            <p style="text-align:left; margin-top:0">-Hair Line<span style="float:right;">$15</span></p>
            <p style="text-align:left; margin-top:0">-Hands<span style="float:right;">$14</span></p>
            <p style="text-align:left; margin-top:0">-Full Arm<span style="float:right;">$34</span></p>
            <p style="text-align:left; margin-top:0">-Full Arm & Pits<span style="float:right;">$42</span></p>
            <p style="text-align:left; margin-top:0">-1/2 Arms<span style="float:right;">$24</span></p>
            <p style="text-align:left; margin-top:0">-Under Arms<span style="float:right;">$15</span></p>
            <p style="text-align:left; margin-top:0">-Full Legs Bikini Included<span style="float:right;">$55</span></p>
            <p style="text-align:left; margin-top:0">-Full Legs w/Brazilian Bikini<span style="float:right;">$69</span></p>
            <p style="text-align:left; margin-top:0">-Full Legs plus butt Bikini included<span style="float:right;">$62</span></p>
            <p style="text-align:left; margin-top:0">-Full Legs w/extra Bikini<span style="float:right;">$62</span></p>
            <p style="text-align:left; margin-top:0">-Upper Legs Bikini included<span style="float:right;">$40</span></p>
            <p style="text-align:left; margin-top:0">-Upper Legs w/extra Bikini<span style="float:right;">$46</span></p>
            <p style="text-align:left; margin-top:0">-Upper Legs w/Brazilian Bikini<span style="float:right;">$59</span></p>
            <p style="text-align:left; margin-top:0">-Lower Legs<span style="float:right;">$25</span></p>
            <p style="text-align:left; margin-top:0">-Bikini<span style="float:right;">$25</span></p>
            <p style="text-align:left; margin-top:0">-Extra Bikini<span style="float:right;">$30</span></p>
            <p style="text-align:left; margin-top:0">-Brazilian Bikini<span style="float:right;">$45</span></p>
            <p style="text-align:left; margin-top:0">-Stomach<span style="float:right;">$12</span></p>
            <p style="text-align:left; margin-top:0">-Butt Cheeks<span style="float:right;">$20</span></p>
            <p style="text-align:left; margin-top:0">-Chest<span style="float:right;">$45</span></p>
            <p style="text-align:left; margin-top:0">-Back including shoulder<span style="float:right;">$50</span></p>
            <p style="text-align:left; margin-top:0">-Back no shoulder<span style="float:right;">$45</span></p>                
            </div>
          </div>
          <div class="col-md-5 col-md-preffix-1">
            <p class="text-md-justify">For Very Sensitive Skin using AZULENE & MAGNOLIA.</p>
            <hr width="100%">
            <div style="color:#614051;">
            <p style="text-align:left; margin-top: 0">-Hair Line<span style="float:right;">$17</span></p>
            <p style="text-align:left; margin-top: 0">-Hands<span style="float:right;">$16</span></p>
            <p style="text-align:left; margin-top: 0">-Full Arm<span style="float:right;">$38</span></p>
            <p style="text-align:left; margin-top: 0">-Full Arm & Pits<span style="float:right;">$44</span></p>
            <p style="text-align:left; margin-top: 0">-1/2 Arms<span style="float:right;">$27</span></p>
            <p style="text-align:left; margin-top: 0">-Under Arms<span style="float:right;">$17</span></p>
            <p style="text-align:left; margin-top: 0">-Full Legs Bikini Included<span style="float:right;">$58</span></p>
            <p style="text-align:left; margin-top: 0">-Full Legs w/Brazilian Bikini<span style="float:right;">$74</span></p>
            <p style="text-align:left; margin-top: 0">-Full Legs plus butt Bikini included<span style="float:right;">$68</span></p>
            <p style="text-align:left; margin-top: 0">-Full Legs w/extra Bikini<span style="float:right;">$65</span></p>
            <p style="text-align:left; margin-top: 0">-Upper Legs Bikini included<span style="float:right;">$43</span></p>
            <p style="text-align:left; margin-top: 0">-Upper Legs w/extra Bikini<span style="float:right;">$50</span></p>
            <p style="text-align:left; margin-top: 0">-Upper Legs w/Brazilian Bikini<span style="float:right;">$62</span></p>
            <p style="text-align:left; margin-top: 0">-Lower Legs<span style="float:right;">$28</span></p>
            <p style="text-align:left; margin-top: 0">-Bikini<span style="float:right;">$28</span></p>
            <p style="text-align:left; margin-top: 0">-Extra Bikini<span style="float:right;">$33</span></p>
            <p style="text-align:left; margin-top: 0">-Brazilian Bikini<span style="float:right;">$50</span></p>
            <p style="text-align:left; margin-top: 0">-Stomach<span style="float:right;">$14</span></p>
            <p style="text-align:left; margin-top: 0">-Butt Cheeks<span style="float:right;">$22</span></p>
            <p style="text-align:left; margin-top: 0">-Chest<span style="float:right;">$50</span></p>
            <p style="text-align:left; margin-top: 0">-Back including shoulder<span style="float:right;">$55</span></p>
            <p style="text-align:left; margin-top: 0">-Back no shoulder<span style="float:right;">$50</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END End Two Columns-->
    
    <!-- Three Column Table-->
    <section class="well well-xs text-md-left text_center_small">
      <div class="container">
        <div class="row offset-3 flow-offset-2">
          <div class="col-md-4 col-lg-3 col-lg-preffix-1">
            <img src="@/assets/images/page-3_img04.jpg" alt="">
          </div>
          <div class="col-md-4 col-lg-3 col-lg-preffix-1">
            <img src="@/assets/images/page-3_img05.jpg" alt="">
          </div>
          <div class="col-md-4 col-lg-3 col-lg-preffix-1">
            <img src="@/assets/images/page-3_img06.jpg" alt="">
          </div>
        </div>
      </div>
    </section>
    
    <div class="divider-1"></div>
  </div>
</template>

<script>
  export default {
    name: 'Service',
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  display: block;
  margin: 0 auto;
}
</style>
